import type { SyncedPortfolioAccount } from '../services/portfolioSyncService';

/** True when this row belongs to the signed-in user (or is legacy-unowned). */
export function isOwnPortfolioAccount(
  account: Pick<SyncedPortfolioAccount, 'ownerUserId'>,
  viewerUserId: string | null | undefined,
): boolean {
  if (!viewerUserId) return false;
  const owner = account.ownerUserId?.trim();
  return !owner || owner === viewerUserId;
}
